export default function Ramp({ className = "" }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 48 48"
      className={className}>
      <path d="M39.8 24.2c-.6-.5-1.6-.4-2.1.2l-2.2 2.7-7.8-5.8c-.4-.3-.8-.4-1.2-.3l-9.2 2.1c-.5.1-1.1 0-1.6-.3s-.8-.8-.9-1.3l-.6-2.5 7.8-1.8c.8-.2 1.3-1 1.1-1.8-.2-.8-1-1.3-1.8-1.1l-7.8 1.8-1.1-4.8c-.2-.8-1-1.3-1.8-1.1-.8.2-1.3 1-1.1 1.8l2.4 10.3c.3 1.3 1.1 2.5 2.3 3.2 1.2.7 2.5 1 3.9.6l8.5-2 8.4 6.2c.3.2.6.3.9.3.4 0 .9-.2 1.2-.6l3.1-3.8c.3-.5.2-1.5-.4-2z" />
      <path d="M26.5 29.1c-.8-.3-1.6 0-2 .8-1.4 3.3-4.3 5.8-7.8 6.6-2.9.7-5.9.2-8.4-1.4-2.5-1.6-4.3-4.1-5-7-1-4.2.5-8.5 3.9-11.2.6-.5.7-1.5.2-2.1-.5-.6-1.5-.7-2.1-.2C1.1 18-.8 23.6.4 28.8c.9 3.7 3.1 6.8 6.3 8.8 2.3 1.4 4.9 2.2 7.5 2.2 1.1 0 2.1-.1 3.2-.4 4.4-1 8.1-4.1 9.9-8.3.3-.8-.1-1.7-.8-2zM9.2 8.9c.3 0 .7 0 1-.1 2.4-.6 3.9-2.9 3.3-5.3C13.1 1.4 11.3 0 9.2 0c-.3 0-.7 0-1 .1-2.4.6-3.8 3-3.3 5.3.5 2.1 2.3 3.5 4.3 3.5zM8 3.7c.1-.2.4-.5.9-.7h.3c.7 0 1.3.5 1.4 1.1.1.5-.1.9-.2 1.1s-.4.5-.9.6h-.3c-.6.1-1.2-.4-1.4-1-.1-.5.1-.9.2-1.1z" />
      <g>
        <path d="M46.5 48h-45c-.8 0-1.4-.6-1.5-1.3-.1-.8.4-1.5 1.2-1.6l45-10c.4-.1.9 0 1.3.3s.6.7.6 1.2v10c-.1.7-.8 1.4-1.6 1.4zm-31.3-3H45v-6.6L15.2 45z" />
      </g>
    </svg>
  )
}
